import React, { useEffect, useState } from "react";
import Axios from "axios";

const FB_APP_ID = "605996212593710";
const CONFIG_ID = "1466184378084906";
const SOLUTION_ID = "1629532304416185";

export default function WhatsAppEmbeddedSignup() {
  const [phoneNumberId, setPhoneNumberId] = useState(null);
  const [wabaId, setWabaId] = useState(null);
  const [error, setError] = useState(null);
  const [remark, setRemark] = useState(null);
  const [code, setCode] = useState(null);

  /* ---------------- FB SDK INIT ---------------- */
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: FB_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v20.0",
      });
      console.log("✅ Facebook SDK initialized");
    };

    if (!document.getElementById("facebook-jssdk")) {
      const js = document.createElement("script");
      js.id = "facebook-jssdk";
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      document.body.appendChild(js);
    }

    const handleMessage = (event) => {
      if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        console.log("📩 Embedded Signup Event:", data);

        if (data.type !== "WA_EMBEDDED_SIGNUP") return;

        if (data.event === "FINISH") {
          setPhoneNumberId((prev) => prev ?? data.data.phone_number_id);
          setWabaId((prev) => prev ?? data.data.waba_id);
          setRemark("FINISH");
        }

        if (data.event === "CANCEL") {
          setRemark("CANCEL");
          setError(data.data.current_step);
        }

        if (data.event === "ERROR") {
          setRemark("ERROR");
          setError(data.data.error_message);
        }
      } catch {
        setRemark("ERROR");
        setError(event.data);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  /* ---------------- FB LOGIN ---------------- */
  const fbLoginCallback = (response) => {

    if (response?.authResponse) {
      setCode(response.authResponse.code);
      console.log("🔑 Auth Code:", response.authResponse.code);
    }else {
      setRemark("CANCEL");
    }
  };

  const launchWhatsAppSignup = () => {
    if (!window.FB) {
      console.error("FB SDK not loaded yet");
      return;
    }

    window.FB.login(fbLoginCallback, {
      config_id: CONFIG_ID,
      response_type: "code",
      override_default_response_type: true,
      extras: {
        setup: { solutionID: SOLUTION_ID },
        sessionInfoVersion: "3",
      },
    });
  };

  /* ---------------- SEND DATA (FIXED) ---------------- */
  useEffect(() => {
    if (!remark) return;

    if (remark === "FINISH" && code && phoneNumberId && wabaId) {
      sendData(phoneNumberId, wabaId, error, remark, code);
    }

    if (remark === "CANCEL") {
      sendData(null, null, error, remark, code);
    }
  }, [remark, code, phoneNumberId, wabaId]);

  const sendData = async (pnid, wabaid, error, remark, code) => {
    try {
      const res = await Axios.post("https://console.authkey.io/api/facebook_embeded_signup_karix_adz.php", {
        accessToken: code,
        user_id: 1,
        user_name: "test@authkey.io",
        method: "insert_token",
        pnid,
        wabaid,
        remark,
        error,
      });
      console.log("✅ Data sent:", res.data);
    } catch (err) {
      console.error("🚨 API Error:", err);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
      <button
        onClick={launchWhatsAppSignup}
        style={{
          backgroundColor: "#1877f2",
          border: 0,
          borderRadius: 4,
          color: "#fff",
          cursor: "pointer",
          fontSize: 16,
          fontWeight: "bold",
          height: 40,
          padding: "0 24px",
        }}
      >
        Continue Embedded Signup AdzNetwork
      </button>
    </div>
  );
}
